'use strict';

angular.module('membership')
  .controller('smsCtrl', [
    '$scope', 'smsViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.company);
    }
  ]);
